/**
 * Dane administratora używane w polityce prywatności, regulaminie, polityce
 * zwrotów i instrukcji usuwania danych.
 *
 * Meta weryfikuje te strony ręcznie, a RODO wymaga wskazania administratora
 * danych z nazwy - pola muszą zawierać prawdziwe dane firmy.
 *
 * Pusty `companyTaxId` znika ze stron (nie zostaje po nim "NIP" bez numeru),
 * więc NIP można uzupełnić później - ale przed publikacją warto go wpisać.
 * Tak samo zachowuje się pusty `companyPhone`.
 */
export const LEGAL = {
    companyName: 'Tymscope Sebastian Gąsiorek-Kowalewicz',
    companyAddress: 'ul. Dzika 4d/21, 65-181 Zielona Góra',
    companyTaxId: '618-197-48-77',
    contactEmail: 'support@genealogy.cards',
    /**
     * Telefon kontaktowy dla kupujących. Paddle wymaga przy weryfikacji konta
     * kontaktu do obsługi kupującego - adresu e-mail ORAZ numeru telefonu -
     * widocznego na stronie. Pusty numer znika ze stopki i ze stron prawnych,
     * więc do czasu uzupełnienia nic się nie psuje, ale weryfikacja Paddle
     * może się o niego upomnieć. Format międzynarodowy, np. '+48 600 000 000'.
     */
    companyPhone: '',
    serviceName: 'genealogy.cards',
    serviceUrl: 'https://genealogy.cards',
    /** Data ostatniej aktualizacji dokumentów */
    lastUpdate: '25 sierpnia 2026',
    /** Podmioty, którym powierzamy dane */
    hostingProvider: 'Hetzner Online GmbH (serwery w Niemczech)',
    /**
     * Operator płatności działający jako sprzedawca formalny (merchant of
     * record): to on zawiera umowę sprzedaży z kupującym, rozlicza VAT,
     * wystawia faktury i obsługuje zwroty. Musi być wskazany z nazwy
     * w regulaminie i w polityce zwrotów.
     */
    paymentProvider: 'Paddle.com Market Ltd'
};
